<ix-view-chart-area [data]="data()" [options]="options()"></ix-view-chart-area>
